<template>
    <transition name="fade">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <form class="modal-container">
                    <div class="modal-body">
                        <div class="form-items form-with-icons" :class="{
                            'form-enabled':
                                values.phone !== undefined &&
                                values.phone !== '',
                        }">
                            <FormulateForm #default="{ hasErrors }" v-model="values">
                                <div v-for="item in schema" :key="item.name">
                                    <vue-tel-input class="telephone" v-if="item.name === 'phone'"
                                        :placeholder="item.placeholder" :label="item.label" v-model="values.phone"
                                        :dropdownOptions="dropdownOptions" @input="checkPhone"></vue-tel-input>
                                    <FormulateInput v-else v-bind="item" :hasErrors="hasErrors" />
                                </div>
                                <!-- <FormulateInput v-for="item in schema" :key="item.name" v-bind="item"
                                    :hasErrors="hasErrors" /> -->
                            </FormulateForm>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-ripple type="button" class="btn" @click="$emit('close')">
                            {{ $t("Cancel") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
export default {
    name: "Modal",

    components: {
        VueTelInput,
    },

    props: ["url", "title", "id"],

    data: function () {
        return {
            values: {
                phone: "",
                message: "",
            },
            schema: [
                {
                    type: "tel",
                    name: "phone",
                    label: ".",
                    placeholder: this.$t("Phone"),
                    validation: "required|starts_with:+|number|max:13,length",
                    help: "+16175551212",
                },
                {
                    type: "customButton",
                    label: this.$t("Send"),
                    formHandler: this.formHandler,
                },
            ],
            dropdownOptions: {
                showDialCodeInSelection: true,
                showFlags: true,
            },
        };
    },

    mounted() {
        this.values.message = `${this.title} - ${this.url}`;
    },

    methods: {
        checkPhone: function (number, phoneObject) {
            if (phoneObject.number !== undefined) {
                this.values.phone = phoneObject.number;
            } else {
                this.values.phone = number;
            }
        },
        formHandler: function () {
            this.values.item_id = this.id;
            this.$http.post("user/sendsms", this.values).then(data => {
                if (data && data.status !== undefined && data.status) {
                    this.$emit("close");
                }
            });
        },
    },
};
</script>
